namespace GeniuzPOS.Points {
    export class PrPointRedeemItemColumns {
        static columnsKey = 'Points.PrPointRedeemItem';
    }
}
